import { CircularProgress, Stack } from '@mui/material'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from './AuthProvider'

export function ProtectedRoute() {
  const auth = useAuth()
  const location = useLocation()
  if (auth.loading) return <Stack minHeight="100vh" alignItems="center" justifyContent="center"><CircularProgress /></Stack>
  if (!auth.authenticated) return <Navigate to="/login" replace state={{ from: location.pathname }} />
  return <Outlet />
}
